<template>
  <div id="printedDictionaries">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-7">
        <div class="breadcrumbs">
          <p :lang=selectedLanguageCode>Du er her:</p>
          <ul>
            <li>
              <router-link tag="a" to="/">{{ $t('message.LEXIN') }}</router-link>
            </li>
            <li>
              <font-awesome-icon icon="arrow-right" class="right-agap"/>
              <span>{{ $t('message.list-printed') }}</span>
            </li>
          </ul>
        </div>
      </div>
      <Language></Language>
    </div>
    <div class="row">
      <div class="col-12">
        <h1>
          <span>{{ $t('message.list-printed') }}</span>
        </h1>
        <div class="clearfix"></div>
        <div class="home-info">
          <p>{{ $t('message.printed-intro-1') }}</p>
          <p>{{ $t('message.printed-intro-2') }}</p>
        </div>
        <div class="clearfix"></div>
        <ul class="inner-info">
          <li>
            <h2>{{ $t('message.norwegian-dari-book-title') }}</h2>
            <p v-html="$t('message.norwegian-dari-book-description')"></p>
          </li>
          <li>
            <h2>{{ $t('message.norwegian-somali-2nd-edition-book-title') }}</h2>
            <p v-html="$t('message.norwegian-somali-2nd-edition-book-description')"></p>
          </li>
          <li>
            <h2>{{ $t('message.norwegian-thai-book-title') }}</h2>
            <p v-html="$t('message.norwegian-thai-book-description')"></p>
          </li>
          <li>
            <h2>{{ $t('message.norwegian-tigrinya-book-title') }}</h2>
            <p v-html="$t('message.norwegian-tigrinya-book-description')"></p>
          </li>
          <li>
            <h2>{{ $t('message.norwegian-somali-book-title') }}</h2>
            <p v-html="$t('message.norwegian-somali-book-description')"></p>
          </li>
          <li>
            <h2>{{ $t('message.norwegian-kurmanji-book-title') }}</h2>
            <p v-html="$t('message.norwegian-kurmanji-book-description')"></p>
          </li>
          <li>
            <h2>{{ $t('message.norwegian-sorani-book-title') }}</h2>
            <p v-html="$t('message.norwegian-sorani-book-description')"></p>
          </li>
          <li>
            <h2>{{ $t('message.norwegian-tamil-book-title') }}</h2>
            <p v-html="$t('message.norwegian-tamil-book-description')"></p>
          </li>
          <li>
            <h2>{{ $t('message.norwegian-illustrated-book-title') }}</h2>
            <p v-html="$t('message.norwegian-illustrated-book-description')"></p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Language from "./Language.vue";
export default {
  name: "PrintedDictionariesComponent",
  data() {
    return {
       languageCodeList:[
        {lang:'eng',langISOCode:'en'},
        {lang:'nny',langISOCode:'nn'},
        {lang:'nbo',langISOCode:'nb'}
      ]
    }
  },
  computed: {
    selectedLanguageCode () {
      return this.languageCodeList.find(x=>x.lang==localStorage.getItem('lang')).langISOCode;
    },
  },
  components: {
    Language
  },
  created() {
    $("body,html").animate(
      {
        scrollTop: 0
      },
      60
    );
  }
};
</script>


